export default __webpack_public_path__ + "static/media/tick-circle.29323018.svg";